import { MIN_PASSWORD_LENGTH } from '@/lib/config';
import { t } from '@/i18n';

/**
 * Shared React Hook Form validation rules, with localized messages. One place so
 * every form validates identically (and Phase 4A-2/4B forms reuse them). The
 * server always re-validates — these are the pre-flight UX layer.
 */
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const rules = {
  name: { required: t('validation.required') },
  email: {
    required: t('validation.required'),
    pattern: { value: EMAIL_RE, message: t('validation.email') },
  },
  /** Any non-empty password (login / current-password — no length hint). */
  password: { required: t('validation.required') },
  /** A password being SET — enforces the minimum length up front. */
  newPassword: {
    required: t('validation.required'),
    minLength: {
      value: MIN_PASSWORD_LENGTH,
      message: t('validation.min', { min: MIN_PASSWORD_LENGTH }),
    },
  },
} as const;
